import React from 'react';

const DiamondFoundryCaption = () => (
  <div className="df__caption">
    This diamond was sustainably created by Diamond Foundry.
  </div>
);

export default DiamondFoundryCaption;
